import WorkspacePage from './vue/pages/WorkspacePage.vue';
import DirectoryPage from './vue/pages/DirectoryPage.vue';
import Router from './vue/pages/Router.vue';
import SettingsPage from './vue/pages/SettingsPage.vue';
import BillingPage from './vue/pages/BillingPage.vue';
import ShortLinkPage from './vue/pages/ShortLinkPage.vue';
import FolderLeavedUser from '@/dashboard/vue/pages/FolderLeavedUser.vue';

export const workspaceRoute = { path: '/w/:short_link', component: WorkspacePage, name: 'workspace' };
export const directoryRoute = { path: '/d/:short_link', component: DirectoryPage, name: 'directory' };
export const folderLeavedUserRoute = { path: '/f/u/:short_link/:user_id', component: FolderLeavedUser, name: 'folderLeavedUser' };

const routes = [
  workspaceRoute,
  directoryRoute,
  folderLeavedUserRoute,
  {
    path: '/settings',
    component: Router,
    children: [
      { path: '', component: SettingsPage, name: 'settings' },
      { path: 'transactions/:workspace_id', component: BillingPage, name: 'transactions' },
    ],
  },
  { path: '/:short_link', component: ShortLinkPage },
];

export default routes;
